import React, { useEffect, useState, createElement } from 'react';
import { SalesPage } from './pages/SalesPage';
import { ThankYouPage } from './pages/ThankYouPage';
export type PageType = 'sales' | 'thankyou';
export function App() {
  const [currentPage, setCurrentPage] = useState<PageType>('sales');
  // SEO meta tags + structured data (runs once)
  useEffect(() => {
    document.documentElement.lang = 'es';
    document.title = 'El Botiquín Antibiótico Natural — 4 Tomos + Bonos | Fegion';
    // Viewport meta (critical for mobile optimization)
    if (!document.querySelector('meta[name="viewport"]')) {
      const vp = document.createElement('meta');
      vp.name = 'viewport';
      vp.content = 'width=device-width, initial-scale=1';
      document.head.appendChild(vp);
    }
    // Charset
    if (!document.querySelector('meta[charset]')) {
      const cs = document.createElement('meta');
      cs.setAttribute('charset', 'utf-8');
      document.head.prepend(cs);
    }
    // Theme color for mobile browsers
    if (!document.querySelector('meta[name="theme-color"]')) {
      const tc = document.createElement('meta');
      tc.name = 'theme-color';
      tc.content = '#070E1A';
      document.head.appendChild(tc);
    }
    const tags: Array<[string, string, string]> = [['name', 'description', 'El Sistema Completo de Salud Familiar Natural. 4 Tomos + 2 Bonos exclusivos. Los 7 Antibióticos Naturales con protocolo de 7 días, dosis exactas y tablas por edad. Envío digital inmediato.'], ['name', 'robots', 'index, follow'], ['property', 'og:title', 'El Botiquín Antibiótico Natural — 4 Tomos + Bonos | Fegion'], ['property', 'og:description', 'Sistema Completo de Salud Familiar Natural. Protocolo de 7 días para frenar infecciones sin recurrir a la farmacia. Con dosis exactas y tablas por edad.'], ['property', 'og:type', 'website'], ['property', 'og:locale', 'es_AR'], ['property', 'og:image', 'https://cdn.magicpatterns.com/uploads/rN2CiMksSwRM2LVZfGn2Pe/heylloyd-image-1773372626707.png'], ['property', 'og:image:width', '600'], ['property', 'og:image:height', '600'], ['property', 'og:image:alt', 'El Botiquín Antibiótico Natural — 4 Tomos Completos'], ['name', 'twitter:card', 'summary_large_image'], ['name', 'twitter:title', 'El Botiquín Antibiótico Natural — 4 Tomos + Bonos'], ['name', 'twitter:description', 'Sistema Completo de Salud Familiar Natural. Protocolo de 7 días para frenar infecciones sin recurrir a la farmacia.'], ['name', 'twitter:image', 'https://cdn.magicpatterns.com/uploads/rN2CiMksSwRM2LVZfGn2Pe/heylloyd-image-1773372626707.png']];
    tags.forEach(([attr, key, content]) => {
      if (!document.querySelector(`meta[${attr}="${key}"]`)) {
        const m = document.createElement('meta');
        m.setAttribute(attr, key);
        m.content = content;
        document.head.appendChild(m);
      }
    });
    // Canonical URL
    if (!document.querySelector('link[rel="canonical"]')) {
      const c = document.createElement('link');
      c.rel = 'canonical';
      c.href = window.location.origin + window.location.pathname;
      document.head.appendChild(c);
    }
    // Structured Data — Product (JSON-LD for SEO)
    if (!document.querySelector('script[type="application/ld+json"]')) {
      const ld = document.createElement('script');
      ld.type = 'application/ld+json';
      ld.textContent = JSON.stringify({
        '@context': 'https://schema.org',
        '@type': 'Product',
        name: 'El Botiquín Antibiótico Natural — 4 Tomos + Bonos',
        description: 'El Sistema Completo de Salud Familiar Natural. 4 Tomos + 2 Bonos exclusivos con protocolo de 7 días, dosis exactas y tablas por edad.',
        image: 'https://cdn.magicpatterns.com/uploads/rN2CiMksSwRM2LVZfGn2Pe/heylloyd-image-1773372626707.png',
        brand: {
          '@type': 'Brand',
          name: 'Fegion'
        },
        offers: {
          '@type': 'Offer',
          price: '12990',
          priceCurrency: 'ARS',
          availability: 'https://schema.org/InStock',
          url: 'https://fegion.shop/cart/46193580441739:1'
        },
        aggregateRating: {
          '@type': 'AggregateRating',
          ratingValue: '5',
          reviewCount: '4'
        }
      });
      document.head.appendChild(ld);
    }
  }, []);
  // Meta Pixel — deferred until browser is idle
  useEffect(() => {
    const loadPixel = () => {
      if (document.getElementById('fb-pixel-init')) return;
      const s = document.createElement('script');
      s.id = 'fb-pixel-init';
      s.innerHTML = `!function(f,b,e,v,n,t,s){if(f.fbq)return;n=f.fbq=function(){n.callMethod?n.callMethod.apply(n,arguments):n.queue.push(arguments)};if(!f._fbq)f._fbq=n;n.push=n;n.loaded=!0;n.version='2.0';n.queue=[];t=b.createElement(e);t.async=!0;t.src=v;s=b.getElementsByTagName(e)[0];s.parentNode.insertBefore(t,s)}(window,document,'script','https://connect.facebook.net/en_US/fbevents.js');fbq('init','904978025482552');fbq('track','PageView');`;
      document.head.appendChild(s);
      const img = document.createElement('img');
      img.height = 1;
      img.width = 1;
      img.style.display = 'none';
      img.src = 'https://www.facebook.com/tr?id=904978025482552&ev=PageView&noscript=1';
      img.alt = '';
      document.body.appendChild(img);
    };
    if (document.readyState === 'complete') {
      if ('requestIdleCallback' in window) {
        ;
        (window as any).requestIdleCallback(loadPixel, {
          timeout: 5000
        });
      } else {
        setTimeout(loadPixel, 4000);
      }
    } else {
      window.addEventListener('load', () => {
        if ('requestIdleCallback' in window) {
          ;
          (window as any).requestIdleCallback(loadPixel, {
            timeout: 5000
          });
        } else {
          setTimeout(loadPixel, 4000);
        }
      }, {
        once: true
      });
    }
  }, []);
  useEffect(() => {
    window.scrollTo(0, 0);
  }, [currentPage]);
  const navigate = (page: PageType) => setCurrentPage(page);
  return <>
      <a href="#main-content" className="skip-link" data-id="element-0">
        Saltar al contenido principal
      </a>
      <div className="min-h-screen bg-gradient-to-b from-navy-900 to-navy-800 text-offwhite font-sans" data-id="element-1">
        {currentPage === 'sales' && <SalesPage navigate={navigate} data-id="element-2" />}
        {currentPage === 'thankyou' && <ThankYouPage navigate={navigate} data-id="element-3" />}
      </div>
    </>;
}